import React from 'react';

const Backdrop = ({ handleClose }) => {
    return (
        <div className="m-backdrop" onClick={handleClose}></div>
    )
}

export default Backdrop
